var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"voz-banner-content"},[_c('div',{staticClass:"voz-banner-image",style:({ backgroundImage: `url(${_vm.vozPageStoreBannerImageSrc})` })}),_c('div',{staticClass:"voz-overlay-image"},[_c('h1',{staticClass:"voz-banner-title"},[_vm._v(" "+_vm._s(_vm.vozPageStoreBannerImageTitle)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }